import React from "react";

export interface FormatNumberProps {
    number?: number;
    currency?: string;
    dataTest?: string;
}

export const formattedNumber = (formatNumber: number | undefined): string => {
    if (formatNumber !== undefined && !isNaN(formatNumber)) {
        return Number(formatNumber).toFixed(2).replace(".", ",");
    }
    return "";
};

const FormatNumber: React.FC<FormatNumberProps> = (props: FormatNumberProps) => {
    return (
        <div style={{ minWidth: "max-content" }} data-test={props.dataTest}>
            {formattedNumber(props.number)} {props.currency}
        </div>
    );
};

export default FormatNumber;
